import { List, ListItem } from 'palette/List';
import { BrandsGroupsListMobile } from '@common/Filters/components/BrandsGorupsListMobile';
import { NoFavouritesInfo } from '@common/Filters/components/NoFavouritesInfo';
import { useBrandsGroupFilter } from '@common/Filters/hooks/useBrandsGroupFilter';
import { useTranslation } from '@common/Hooks/useTranslation';

export function BrandsGroup({ brands, brandGroupsData, activeBrandIds }) {
    const translate = useTranslation();
    const { hasHighlightedFilters, hasFavourites } = useBrandsGroupFilter(brandGroupsData, brands);

    return (
        <>
            { !hasFavourites && <NoFavouritesInfo />}
            {
                hasHighlightedFilters && (
                    <div className="filters__list filters__list--groups ">
                        <List>
                            <ListItem
                                label={translate('listing.filter.brandgroup.headline')}
                                labelType="large-title"
                                verticalAlignment="bottom"
                            />
                            <BrandsGroupsListMobile
                                activeBrandIds={activeBrandIds}
                                brandGroupsData={brandGroupsData}
                                brands={brands}
                            />
                        </List>
                    </div>
                )
            }
        </>
    );
}
